<div class="ml-[220px] flex min-h-[86vh] flex-col gap-6 py-4">
  <div class="inline-flex w-full items-end justify-between px-6">
    <h2 class="textTabsColor text-3xl font-bold" i18n="@@companiesTitle">Companies</h2>
  </div>

  @if (errorMessage()) {
    <div class="textTabsColor px-6 text-center text-lg">
      {{ errorMessage() }}
    </div>
  } @else {
    <div class="flex flex-wrap gap-8 px-8">
      @for (company of paginatedCompanies(); track company.id) {
        <div
          (click)="viewCompany(company)"
          class="group hover-shadow-primary-15 relative flex h-64 w-52 cursor-pointer flex-col items-center justify-between overflow-hidden rounded-[2.5rem] border border-gray-100 bg-white p-6 shadow-[0_10px_40px_rgba(0,0,0,0.04)] transition-all duration-500 hover:-translate-y-3">
          <div
            class="relative z-10 flex h-36 w-36 items-center justify-center rounded-3xl bg-gray-50 transition-all duration-500 group-hover:bg-white">
            @let imageData = companyImages.get(company.id);

            @if (imageData && imageData.isImage) {
              <img
                [src]="imageData.url"
                [alt]="getLocalizedTitle(company)"
                class="h-full w-full object-contain p-3 transition-transform duration-500 group-hover:scale-110" />
            } @else {
              <app-companies-icon />
            }
          </div>

          <div class="flex flex-1 items-center justify-center pt-3">
            <span
              class="group-hover:textTabsColor line-clamp-2 px-2 text-center text-lg leading-snug font-bold text-gray-800 transition-colors duration-300">
              {{ getLocalizedTitle(company) }}
            </span>
          </div>

          <div
            class="bg-card-glow absolute -right-14 -bottom-14 h-40 w-40 rounded-full blur-3xl transition-transform duration-700 group-hover:scale-150"></div>

          <div
            class="bg-card-underline absolute bottom-0 left-0 h-2 w-0 rounded-full transition-all duration-500 group-hover:w-full"></div>
        </div>
      }
    </div>

    <div class="mt-2 flex items-center justify-center gap-2">
      <button
        (click)="changePage(currentPage() - 1)"
        [disabled]="currentPage() == 1"
        class="flex h-10 w-10 items-center justify-center rounded-full text-black transition enabled:hover:cursor-pointer enabled:hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50">
        <app-arrow-nav-icon direction="left" />
      </button>

      @for (page of pagesArray; track page) {
        <button
          (click)="changePage(page)"
          [class.bg-pagination-bg]="page == currentPage()"
          [class.text-primary]="page == currentPage()"
          [class.font-bold]="page == currentPage()"
          [class.text-gray-500]="page != currentPage()"
          [class.hover:bg-gray-100]="page != currentPage()"
          class="flex h-10 w-10 items-center justify-center rounded-full text-lg font-medium transition-colors hover:cursor-pointer">
          {{ page }}
        </button>
      }

      <button
        (click)="changePage(currentPage() + 1)"
        [disabled]="currentPage() == totalPages()"
        class="flex h-10 w-10 items-center justify-center rounded-full text-black transition enabled:hover:cursor-pointer enabled:hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50">
        <app-arrow-nav-icon direction="right" />
      </button>
    </div>
  }
</div>
